"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateRangePicker = exports.useDateRangePicker = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
require("react-date-range/dist/styles.css"); // main style file
require("react-date-range/dist/theme/default.css"); // theme css file
require("./DateRangePicker.css");
var react_date_range_1 = require("react-date-range");
var Row_1 = require("../../components/Row");
var Button_1 = require("../../components/Button");
var Stack_1 = require("../../components/Stack");
var R = __importStar(require("../../utils/ramda"));
var classnames_1 = __importDefault(require("classnames"));
var luxon_1 = require("luxon");
var DateRangeSidebar_1 = require("./DateRangeSidebar");
var locale_1 = require("../../utils/locale");
var fromVSXDate = function (date) {
  if (Array.isArray(date)) {
    var d = new Date();
    d.setFullYear(Number(date[0]), Number(date[1]), Number(date[2]));
    return d;
  }
  if (typeof date === "string") {
    return luxon_1.DateTime.fromFormat(date, "yyyy-MM-dd").toLocal().toJSDate();
  }
  return date;
};
var fromVSXDateRange = function (rn, key) {
  var m = rn.map(fromVSXDate);
  return {
    startDate: m[0],
    endDate: m[1],
    key: key
  };
};
/**
 * @param rangeConfigs Each `rangeConfig` defines a calendar from which users can select a range
 * @param options Miscellaneous configuration options for DateRangePicker
 * @returns
 * ```
 * [
 *  config, // to be spread into <DateRangePicker/>
 *  ranges, // dictionary of range IDs and their start/end dates
 *  updateRange // function to update a range with new properties
 * ]
 * ```
 */
var useDateRangePicker = function (rangeConfigs, options) {
  var _ranges = rangeConfigs.reduce(function (acc, item) {
    var key = item.key;
    var part = item.startingRange ? fromVSXDateRange(item.startingRange, key) : {
      key: key,
      startDate: new Date(),
      endDate: new Date()
    };
    var newItem = __assign(__assign({}, R.dissoc("startingRange", item)), part);
    return R.assoc(key, newItem, acc);
  }, {});
  var keyOrder = rangeConfigs.map(function (rg) {
    return rg.key;
  });
  var _a = __read((0, react_1.useState)(_ranges), 2),
    selectedRanges = _a[0],
    setSelectedRanges = _a[1];
  var _b = __read((0, react_1.useState)(_ranges), 2),
    appliedRanges = _b[0],
    setAppliedRanges = _b[1];
  var ranges = (0, react_1.useMemo)(function () {
    var mapFn = function (v) {
      return [v.startDate, v.endDate];
    };
    return R.mapObjIndexed(mapFn, appliedRanges);
  }, [appliedRanges]);
  var updateRange = function (key, value) {
    return setSelectedRanges(function (prev) {
      return R.assoc(key, __assign(__assign({}, prev[key]), value), prev);
    });
  };
  var areRangesApplied = R.equals(selectedRanges, appliedRanges);
  var forceApply = function (ranges) {
    var newRanges = R.mergeDeepRight(selectedRanges, ranges);
    setAppliedRanges(newRanges);
    setSelectedRanges(newRanges);
  };
  var config = __assign({
    keyOrder: keyOrder,
    selectedRanges: selectedRanges,
    /** Unused, but left for legacy purposes */
    appliedRanges: appliedRanges,
    areRangesApplied: areRangesApplied,
    onApply: function () {
      return setAppliedRanges(selectedRanges);
    },
    onCancel: function () {
      return setSelectedRanges(appliedRanges);
    },
    forceApply: forceApply,
    onChange: function (newValues) {
      return setSelectedRanges(__assign(__assign({}, selectedRanges), newValues));
    }
  }, options);
  return [config, ranges, updateRange];
};
exports.useDateRangePicker = useDateRangePicker;
var DateRangePicker = function (_a) {
  var keyOrder = _a.keyOrder,
    selectedRanges = _a.selectedRanges,
    isSidebarApplied = _a.isSidebarApplied,
    areRangesApplied = _a.areRangesApplied,
    onApply = _a.onApply,
    onCancel = _a.onCancel,
    onChange = _a.onChange,
    _b = _a.locale,
    locale = _b === void 0 ? "en" : _b,
    _c = _a.cancelButtonText,
    cancelButtonText = _c === void 0 ? "Cancel" : _c,
    _d = _a.applyButtonText,
    applyButtonText = _d === void 0 ? "Apply" : _d,
    className = _a.className,
    minDate = _a.minDate,
    maxDate = _a.maxDate,
    sidebarSections = _a.sidebarSections,
    _e = _a.onApplySidebar,
    onApplySidebar = _e === void 0 ? R.N : _e,
    _f = _a.onCancelSidebar,
    onCancelSidebar = _f === void 0 ? R.N : _f,
    setSidebarSelection = _a.setSidebarSelection,
    _restProps = __rest(_a, ["keyOrder", "selectedRanges", "isSidebarApplied", "areRangesApplied", "onApply", "onCancel", "onChange", "locale", "cancelButtonText", "applyButtonText", "className", "minDate", "maxDate", "sidebarSections", "onApplySidebar", "onCancelSidebar", "setSidebarSelection"]);
  var restProps = R.omit(["appliedRanges", "forceApply", "forceApplySidebar", "setSidebarSections"], _restProps);
  var buttonsDisabled = isSidebarApplied && areRangesApplied;
  var props = {
    onChange: onChange,
    locale: locale_1.languageToLocale[locale],
    minDate: fromVSXDate(minDate),
    maxDate: fromVSXDate(maxDate)
  };
  var _onCancel = function () {
    onCancel();
    onCancelSidebar();
  };
  var _onApply = function () {
    onApply();
    onApplySidebar();
  };
  return (0, jsx_runtime_1.jsxs)(Stack_1.Stack, __assign({
    inline: true
  }, restProps, {
    className: (0, classnames_1.default)("vsx-date-range-picker", className)
  }, {
    children: [(0, jsx_runtime_1.jsxs)(Row_1.Row, {
      children: [(0, jsx_runtime_1.jsx)(DateRangeSidebar_1.DateRangeSidebar, {
        sections: sidebarSections,
        setSelected: setSidebarSelection
      }), keyOrder.map(function (k) {
        var range = selectedRanges[k];
        return range.hidden ? null : (0, jsx_runtime_1.jsx)(react_date_range_1.DateRange, __assign({}, props, {
          fixedHeight: true,
          disabledDay: range.disabled ? R.T : undefined,
          ranges: [R.dissoc("disabled", range)]
        }), k);
      })]
    }), (0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
      className: "vsx-date-range-picker-button-bar",
      gap: "medium"
    }, {
      children: [(0, jsx_runtime_1.jsx)(Button_1.Button, __assign({
        disabled: buttonsDisabled,
        type: "tertiary",
        onClick: _onCancel
      }, {
        children: cancelButtonText
      })), (0, jsx_runtime_1.jsx)(Button_1.Button, __assign({
        disabled: buttonsDisabled,
        type: "primary",
        onClick: _onApply
      }, {
        children: applyButtonText
      }))]
    }))]
  }));
};
exports.DateRangePicker = DateRangePicker;